import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from './pages/HomePage'
import './App.css';
import 'leaflet/dist/leaflet.css'
import './bootstrap.rtl.min.css';


function App() {
  return (
    <div className="App">
      <header className="App-header">
       
         <Router>
            <Routes>
              <Route path='/' element={<HomePage/>} exact />
            </Routes>
          </Router>
      </header>
    </div>
  );
}

export default App;
